<template>
  <div class="action-container">
    <bimContainer>
      <div class="action-time">
        <bim-text adaptive bold type=accent class="text-center action-time__title">Мастер спецификаций BIMLIB</bim-text>
        <bim-text adaptive bold type=h4 class="text-center mt-10 mb-11 action-time__desc">Будущее для проектировщиков пришло!</bim-text>
        <ButtonPluginDownload title="Скачать бесплатно" class="text-center" />
      </div>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import ButtonPluginDownload from "./ButtonPluginDownload"
export default {
  name: "BlockActionTime",
  components: {
    bimContainer,
    ButtonPluginDownload,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.action-container {
  width: 100%;
  background-color: $primary-color-75;
  padding: 100px 0;

  .action-time__title {
    @media screen and (max-width: $breakpoint-sm) {
      font-size: 18px;
    }
  }

  .action-time__desc {
    max-width: 677px;
    margin: auto;

    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 24px;
      }
    }
  }
}

.text-center {
  text-align: center;
}
</style>
